import { Component, _decorator } from 'cc';
import { DEV } from 'cc/env';

const { ccclass, property, executeInEditMode } = _decorator;

enum EventType {
    ATTACH = 'ATTACH',
    DETACH = 'DETACH',
    FLEX_FACTOR_CHANGED = 'FLEX_FACTOR_CHANGED',
}

@ccclass('FlexItem')
@executeInEditMode
export default class FlexItem extends Component {
    public static readonly EVENT_TYPE = EventType;

    @property
    private _flexFactor: number = 1;

    @property({ min: 0, tooltip: DEV && 'The flex factor of item.' })
    public get flexFactor(): number {
        return this._flexFactor;
    }
    public set flexFactor(value: number) {
        value = Math.max(0, value);
        if (this._flexFactor === value) {
            return;
        }
        this._flexFactor = value;
        this.node.emit(EventType.FLEX_FACTOR_CHANGED, this._flexFactor);
    }

    protected onLoad() {
        this.node.emit(EventType.ATTACH, this);
    }

    protected onDestroy() {
        this.node.emit(EventType.DETACH, this);
    }
}
